// Centralized experience data (structure inspired by timeline style sites)
// Adjust / expand with your own real content.
export const experience = [
  {
    company: 'N-able Private Limited',
    role: 'Software Engineer Intern',
    period: '2026 Jan – Present',
    summary: 'Responsible for designing and developing enterprise-grade backend services using Spring Boot within a microservices architecture. Contribute to building scalable and maintainable APIs, implement business logic, and support system integration. Collaborate with the development team to follow best coding practices, improve system performance, and assist in deploying and maintaining backend services.',
  },
  
];
